<!-- PaymentIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">                
    <rect x="24" y="24" width="24" height="24" rx="12" transform="rotate(-180 24 24)" fill="#F2F2F2"/>
    <path d="M15.3337 10.3333L12.1574 13.5996C12.0707 13.6889 11.93 13.6889 11.8433 13.5996L8.66699 10.3333" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
